import React from "react";
import { CrudPage } from "@/components/CrudPage";
import { Money } from "@/components/common";

const CATEGORIES = ["Tour Package", "Hotel", "Cab", "Tempo Traveller", "Airport Transfer",
  "Sightseeing", "Activity", "Travel Service", "Other"];

export default function Services() {
  return (
    <CrudPage title="Services & Packages" subtitle="Service catalog with SAC codes and per-service GST rates"
      testid="services" endpoint="/services" searchPlaceholder="Search service, SAC…"
      createLabel="New Service"
      defaults={{ name: "", category: "Tour Package", description: "", sac: "", gst_rate: 5,
        unit: "Package", price: 0, cost_price: 0, active: true }}
      columns={[
        { key: "name", label: "Service", render: (r) => (
          <div><span className="font-medium">{r.name}</span>{r.is_demo && <span className="ml-1 text-[10px] font-bold text-[#8a6d14]">DEMO</span>}
            <div className="text-xs text-[#5C6B69] line-clamp-1 max-w-72">{r.description}</div></div>) },
        { key: "category", label: "Category" },
        { key: "sac", label: "SAC" },
        { key: "gst_rate", label: "GST", align: "right", render: (r) => `${r.gst_rate}%` },
        { key: "unit", label: "Unit" },
        { key: "price", label: "Selling Price", align: "right", render: (r) => <Money value={r.price} className="font-semibold" /> },
        { key: "cost_price", label: "Cost", align: "right", render: (r) => <Money value={r.cost_price} /> },
        { key: "active", label: "Status", render: (r) => r.active
          ? <span className="text-xs font-bold text-emerald-600">Active</span>
          : <span className="text-xs text-slate-400">Inactive</span> },
      ]}
      fields={[
        { key: "name", label: "Service Name", required: true },
        { key: "category", label: "Category", type: "select",
          options: CATEGORIES.map((c) => ({ value: c, label: c })) },
        { key: "description", label: "Description", type: "textarea", full: true },
        { key: "sac", label: "SAC Code", hint: "e.g. 998551 for tour operator services" },
        { key: "gst_rate", label: "Default GST Rate %", type: "select", numeric: true,
          options: [0, 5, 12, 18, 28].map((r) => ({ value: r, label: `${r}%` })) },
        { key: "unit", label: "Unit", placeholder: "Package / Night / Trip / Day" },
        { key: "price", label: "Selling Price (₹)", type: "number" },
        { key: "cost_price", label: "Cost Price (₹)", type: "number", hint: "Used for profitability estimates" },
        { key: "active", label: "Active", type: "checkbox", checkboxLabel: "Available for booking & invoicing" },
      ]} />
  );
}
